import type { ReactElement } from "react";

import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { StyledContainer, StyledInnerContainer } from "./styles";

type AddProfileProps = {
    isDisabled: boolean;
    onAddClick(): void;
};

const AddProfile = ({ isDisabled, onAddClick }: AddProfileProps): ReactElement => {
    const translate = useTranslation();

    function handleClick() {
        if (!isDisabled) {
            onAddClick();
        }
    }

    return (
        <StyledContainer>
            <PlainTooltip
                tooltipContent={translate(
                    isDisabled
                        ? "si.contacts-search-profiles.button.add.disabled.tooltip"
                        : "si.contacts-search-profiles.button.add.tooltip",
                )}
            >
                <StyledInnerContainer>
                    <IconButton
                        type="flat"
                        iconName="add"
                        onClick={handleClick}
                        isDisabled={isDisabled}
                        dataAutomation="add-profile-button"
                    >
                        {translate("si.contacts-search-profiles.button.add")}
                    </IconButton>
                </StyledInnerContainer>
            </PlainTooltip>
        </StyledContainer>
    );
};

export default AddProfile;
